import { AreaComumValor } from 'core/features/reservas/typings/index';
import { AreaComumDia } from 'core/features/area-comum/enums/index';

export function groupValuesByDateAndType({valores}: {valores: AreaComumValor[]}) {
  const _items: {texto: string; valor: number}[] = [];

  const valorFeriado = valores.find(
    i => i.criterioValor === AreaComumDia.Feriado,
  );
  const valorDiaAntesFeriado = valores.find(
    i => i.criterioValor === AreaComumDia.DiaAntesFeriado,
  );
  const valorDiaDepoisFeriado = valores.find(
    i => i.criterioValor === AreaComumDia.DiaDepoisFeriado,
  );

  if (valorFeriado) {
    _items.push({
      texto: mapCriterioDia(AreaComumDia.Feriado) + 's',
      valor: valorFeriado.valor!,
    });
  }

  if (valorDiaAntesFeriado) {
    _items.push({
      texto: mapCriterioDia(AreaComumDia.DiaAntesFeriado),
      valor: valorDiaAntesFeriado.valor!,
    });
  }

  if (valorDiaDepoisFeriado) {
    _items.push({
      texto: mapCriterioDia(AreaComumDia.DiaDepoisFeriado),
      valor: valorDiaDepoisFeriado.valor!,
    });
  }

  const groups = groupBySameValue(
    valores.filter(
      v =>
        v.criterioValor !== AreaComumDia.DiaAntesFeriado &&
        v.criterioValor !== AreaComumDia.DiaDepoisFeriado &&
        v.criterioValor !== AreaComumDia.Feriado,
    ),
  );

  Object.keys(groups).forEach(valor => {
    const group = groups[valor];
    const texto = getLabelForGroup(group);

    _items.push({texto, valor: Number(valor)});
  });

  return _items;
}

export const mapCriterioDia = (criterio: AreaComumDia) => {
  switch (criterio) {
    case AreaComumDia.DiaAntesFeriado:
      return 'Um dia antes do feriado';
    case AreaComumDia.DiaDepoisFeriado:
      return 'Um dia depois do feriado';
    case AreaComumDia.Terca:
      return 'terça';
    case AreaComumDia.Sabado:
      return 'sábado';
    default:
      return criterio;
  }
};

export const groupBySameValue = (valores: AreaComumValor[]) => {
  const sortedByDay = valores.sort(
    (a, b) =>
      dayOrderArray.findIndex(i => i === a.criterioValor) -
      dayOrderArray.findIndex(i => i === b.criterioValor),
  );

  const grouped = sortedByDay.reduce((acc, next) => {
    if (next.valor !== null) {
      if (acc[`${next.valor}`]) {
        acc[`${next.valor}`].push(next);
      } else {
        acc[`${next.valor}`] = [next];
      }
    }

    return acc;
  }, {} as Record<string, AreaComumValor[]>);

  return grouped;
};

export const getLabelForGroup = (group: AreaComumValor[]) => {
  if (group.length > 2) {
    return `De ${mapCriterioDia(group[0].criterioValor)} à ${mapCriterioDia(
      group[group.length - 1].criterioValor,
    )}`;
  } else if (group.length === 2) {
    return `${mapCriterioDia(group[0].criterioValor)}s e ${mapCriterioDia(
      group[group.length - 1].criterioValor,
    )}s`;
  }

  return `${mapCriterioDia(group[0].criterioValor)}s`;
};

export const dayOrderArray = [
  AreaComumDia.Feriado,
  AreaComumDia.DiaAntesFeriado,
  AreaComumDia.DiaDepoisFeriado,
  AreaComumDia.Domingo,
  AreaComumDia.Segunda,
  AreaComumDia.Terca,
  AreaComumDia.Quarta,
  AreaComumDia.Quinta,
  AreaComumDia.Sexta,
  AreaComumDia.Sabado,
];